import React, {Component, PropTypes} from 'react'
import {Row, Col} from 'react-bootstrap'
import cx from 'classnames'
import Icon from './Icon'
import style from './Picker.less'

function sourceFilter(value, identify, multi) {
    if (multi) {
        return (item) => {
            return !(value && value.find((v) => identify(v) == identify(item)))
        }
    }

    const valueId = value && identify(value)
    return (item) => {
        return !(valueId == identify(item))
    }
}

class Picker extends Component {
    static propTypes = {
        source: PropTypes.array.isRequired,
        display: PropTypes.func,
        identify: PropTypes.func,
        disable: PropTypes.func,
        header: PropTypes.object,
        after: PropTypes.object,
        split: PropTypes.bool,
        multi: PropTypes.bool,
        size: PropTypes.string,
        bsStyle: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func,
        onSubmit: PropTypes.func
    }

    static defaultProps = {
        display: (v) => v,
        identify: (v) => v,
        disable: (v) => false
    }

    constructor(props) {
        super(props)

        this.state = {
            filteredSource: []
        }
    }

    componentWillMount() {
        const {source, value, identify, multi} = this.props

        const filteredSource = source.filter(sourceFilter(value, identify, multi))
        this.setState({filteredSource})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.source != this.props.source
            || nextProps.value != this.props.value) {
            const {source, value, identify, multi} = nextProps

            const filteredSource = source.filter(sourceFilter(value, identify, multi))
            this.setState({filteredSource})
        }
    }

    _add(event, item) {
        const {multi, identify, value, onChange, onSubmit} = this.props

        event.preventDefault()

        if (multi) {
            const previousValue = value || []
            const itemId = identify(item)
            const index = previousValue.findIndex((value) => identify(value) == itemId)

            if (index < 0) {
                if (onSubmit) {
                    onSubmit('Add', item)
                }

                if (onChange) {
                    var nextValue = [...previousValue]
                    nextValue.push(item)
                    onChange(nextValue)
                }
            }
        } else {
            if ((value && identify(value)) != identify(item)) {
                if (onSubmit) {
                    onSubmit('Add', item)
                }

                if (onChange) {
                    onChange(item)
                }
            }
        }
    }

    _remove(event, item) {
        const {multi, identify, value, onChange, onSubmit} = this.props

        event.preventDefault()

        if (multi) {
            const previousValue = value || []
            const itemId = identify(item)
            const index = previousValue.findIndex((value) => identify(value) == itemId)

            if (index >= 0) {
                if (onSubmit) {
                    onSubmit('Remove', item)
                }

                if (onChange) {
                    var nextValue = [...previousValue]
                    nextValue.splice(index, 1)
                    onChange(nextValue)
                }
            }
        } else {
            if ((value && identify(value)) == identify(item)) {
                if (onSubmit) {
                    onSubmit('Remove', value)
                }

                if (onChange) {
                    onChange(null)
                }
            }
        }
    }

    render() {
        const {source, display, identify, disable, header, after, split, multi, size, bsStyle, value, onChange, onSubmit, children, ...other} = this.props
        const {filteredSource} = this.state
        const sizeClass = size && size.toLowerCase()

        return (
            <div className={cx(style.default, style[sizeClass], {[style.error]: bsStyle == 'error'})}>
                <Row>
                    {split && children && (
                        <Col sm={4}>
                            <div className={style.body}>
                                {children}
                            </div>
                        </Col>
                    )}
                    <Col sm={split && (children && 4 || 6) || 12}>
                        {(split || !value) && (
                            <div>
                                {header}
                                <ul className={style.result}>
                                    {filteredSource.map((item) => (
                                        <li
                                            className={cx({[style.disabled]: disable(item)})}
                                            key={identify(item)}>
                                            <a
                                                href=''
                                                className={style.add}
                                                onClick={(e) => !disable(item) && this._add(e, item) || e.preventDefault()}>
                                                <Icon icon='plus' size='xs' />
                                            </a>
                                            <p>{display(item)}</p>
                                        </li>
                                    ))}
                                    {after && (
                                        <li
                                            key='after'
                                            className={style.after}>
                                            {after}
                                        </li>
                                    )}
                                </ul>
                            </div>
                        )}
                    </Col>
                    <Col sm={split && (children && 4 || 6) || 12}>
                        {!multi && value && (
                            <div className={style.picked}>
                                <div className={style.remove}>
                                    <a
                                        href=''
                                        onClick={(e) => this._remove(e, value)}>
                                        <Icon icon='minus' size='xs' />
                                    </a>
                                </div>
                                <div className={style.container}>
                                    {display(value, 'Picked')}
                                </div>
                            </div>
                        )}
                        {multi && value && (
                            <ul className={style.result}>
                                {value.map((value) => (
                                    <li
                                        className={cx({[style.disabled]: disable(value)})}
                                        key={identify(value)}>
                                        <a
                                            href=''
                                            className={style.remove}
                                            onClick={(e) => !disable(value) && this._remove(e, value) || e.preventDefault()}>
                                            <Icon icon='minus' size='xs' />
                                        </a>
                                        <p>{display(value)}</p>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </Col>
                </Row>
            </div>
        )
    }
}

export default Picker


// WEBPACK FOOTER //
// ./lib/core/components/Picker.js